import { AUTO_API } from '@constants/fastagConstants'
import { RESPONSE } from '@factories/vasApiResponseConstants'
import { API_URL_FACTORY } from '@factories/apiUrlFactory'
import { fetchWithTimeout } from '@utils/utils'
import { MOTOR_ORCHESTOR_FETCH_TIMEOUT } from '@constants/times'

export const autoService = async (regNo): Promise<any> => {
  try {
    const apiUrl = API_URL_FACTORY.VEHICLE_INFO_API(regNo) ? API_URL_FACTORY.VEHICLE_INFO_API(regNo) : AUTO_API(regNo)
    const options = {
      timeout: MOTOR_ORCHESTOR_FETCH_TIMEOUT,
    }
    const response = await fetchWithTimeout(apiUrl, options)

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()

    // Return the fetched data
    return data
  } catch (err) {
    console.error(err, RESPONSE.ERROR_AUTO_API)
    return null
  }
}
